function Footer() {
  return (
    <footer className="site-footer">
      <div className="wd-8 w-100">
        <div className="d-flex flex-column flex-md-row align-items-center justify-content-between gap-3">

          {/* Brand */}
          <div>
            <span className="footer-brand">INIOBONG PIUS</span>
            <p className="footer-tagline">Building digital experiences that matter.</p>
          </div>

          {/* Right: socials + copy */}
          <div className="d-flex flex-column align-items-center align-items-md-end gap-2">
            <div className="footer-social">
              <a href="https://www.linkedin.com/in/piusiniobong/" target="_blank" rel="noreferrer" aria-label="LinkedIn">
                <img src={require('./../assets/images/linkedin.svg').default} alt="LinkedIn" />
              </a>
              <a href="https://hashnode.com/@pye" target="_blank" rel="noreferrer" aria-label="Hashnode">
                <img src={require('./../assets/images/hashnode.svg').default} alt="Hashnode" />
              </a>
              <a href="https://github.com/payose" target="_blank" rel="noreferrer" aria-label="GitHub">
                <img src={require('./../assets/images/github.svg').default} alt="GitHub" />
              </a>
            </div>
            <p className="footer-copy">© {new Date().getFullYear()} Iniobong Pius. All rights reserved.</p>
          </div>

        </div>
      </div>
    </footer>
  );
}

export default Footer;
